<template>
    <Card>
        <div class="card-body">
            <AlphaButton color="teal" class="mr-2" @click="$router.push({ name: 'CreateExitDeclarationStatusPage' })">
                <span>{{ $t('buttons.create') }}</span>
            </AlphaButton>
        </div>
        <FetchTable :handle="tableHandle" :columns="table.columns" :url="table.url" v-model:orders="table.orders">
            <template #td-name="{row}">
                <router-link :to="{ name: 'EditExitDeclarationStatusPage', params: { exitDeclarationStatusUuid: row.uuid } }">{{ row.name }}</router-link>
            </template>
            <template #td-type="{row}">
                <span :class="`badge`" :style="{
                    'color': 'white',
                    'background-color': row.color
                }">{{ $t(`enum.exit-declaration-status.type.${row.type}`) }}</span>
            </template>
            <template #td-created_at="{row}">
                {{ DateFormatter.formatDateTime(row.created_at) }}
            </template>
        </FetchTable>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import FetchTable from '../../../../components/new/table/FetchTable.vue';
import { createTableHandle } from '../../../../components/new/table/tableHandle';
import AlphaButton from '../../../../components/new/button/AlphaButton.vue';
import DateFormatter from '../../../../services/DateFormatter';
export default {
    name: "IndexExitDeclarationStatusPage",
    components: {
        Card, FetchTable, AlphaButton
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            table: {
                url: '/management/exit-declaration-statuses',
                orders: [],
                columns: [
                    {key: 'id', name: this.$t('table.titles.id'), width: '80px', type: 'string', order: true},
                    {key: 'name', name: this.$t('labels.name'), width: 'auto', type: 'string', order: true},
                    {key: 'type', name: this.$t('labels.type'), width: '200px', type: 'string', order: true},
                    {key: 'order', name: this.$t('labels.queue'), width: '200px', type: 'string', order: true},
                    {key: 'created_at', name: this.$t('table.titles.created_at'), width: '200px', type: 'string', order: true},
                ]
            }
        }
    },
    mounted() {
        this.tableHandle.fetchRows()
    }
}
</script>
